import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteCustomer, getCustomers } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const CustomerList = () => {
    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleCustomers();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteCustomer(id, { archive: true });
            if (data.success) handleCustomers();
        } catch (err) { }
    };

    const handleCustomers = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getCustomers(params);
            const { resultsPerPage, totalCount, customers, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(customers.map(customer => {
                return {
                    nameLocal: customer.nameLocal || '-',
                    country: customer?.country || '-',
                    code: customer?.essalyCode || '',
                    createdAt: customer.createdAt,
                    email: customer?.email || '',
                    phone: customer?.phone || '',
                    name: customer.name || '',
                    _id: customer._id,
                }
            }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleCustomers(page);
    };

    const AddCustomer = () => navigate('/customer/create');

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_expense_category',
                        title: 'customer_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleCustomers,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_customer',
                                action: AddCustomer,
                                icon: 'plus',

                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleCustomers} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={6}
                                type="customer"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomerList;